import { useAnimate } from 'motion/react';
import { useEffect, useRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { NumberInput, NumberInputProps } from '@flipster/ui';
import { colorGray8, colorWhite } from '@flipster/ui/styles';

interface ControlProps extends Omit<NumberInputProps, 'value'> {
  name: string;
  isFocused: boolean;
}

export const AmountInput = ({ name, isFocused, onChange: onChangeCallback, ...restProps }: ControlProps) => {
  const [scope, animate] = useAnimate();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const prevValue = useRef(value);

  useEffect(() => {
    if (isFocused || prevValue.current === value) return;
    prevValue.current = value;
    animate([
      [scope.current, { color: colorGray8 }, { duration: 0.2 }],
      [scope.current, { color: colorWhite }],
    ]);
  }, [animate, scope, value, isFocused]);

  return (
    <NumberInput
      ref={scope}
      value={value || undefined}
      onChange={(newValue) => {
        onChange(newValue);
        onChangeCallback?.(newValue);
      }}
      {...restProps}
    />
  );
};
